"use strict";
import {ClientEventType} from "../../services/client-events/models/ClientEventType";

{
    var app = angular.module("tf.portfolio.widgets.tf-payoff", [])
        .controller("tfPayoffChartCtrl",
            ["$scope", "$localStorage", "$http", "$document", "$timeout", "$filter", "clientEventService",
                function tfPayoffChartCtrl($scope, $localStorage, $http, $document, $timeout, $filter, clientEventService) {

            const sub = clientEventService.events()
                                          .filter((evt) => evt.type === ClientEventType.BROKER_STATE_CHANGED)
                                          .subscribe(() => $scope.calculatePayoff());

            $scope.$on("$destroy", () => sub.unsubscribe());

            $scope.getAvailSecurities = function () {
                var securities = [];
                if ($scope.whatIf && $scope.whatIf.positions) {
                    if ($scope.whatIf.positions) {
                        for (var i = 0; i < $scope.whatIf.positions.length; i++) {
                            securities.push($scope.whatIf.positions[i].code.substring(0, 3));
                        }
                    }
                }
                if ($scope.payoff.includeRealPositions && $scope.realPositions) {
                    for (var j = 0; j < $scope.realPositions.length; j++) {
                        securities.push($scope.realPositions[j].code.substring(0, 3));
                    }
                }
                $scope.securities = securities.filter(function (elem, pos) {
                    return securities.indexOf(elem) === pos;
                });

                if ($scope.securities.length === 1) {
                    $scope.filteredSecurity = $scope.securities[0];
                }

                $scope.securities.sort(byValue);
                return $scope.securities;
            };

            function byValue(a, b) {
                if (a > b) {
                    return 1;
                }
                if (b > a) {
                    return -1;
                }
                return 0;
            }

            $scope.filteredSecurity = null;

            $scope.filterPayoff = function (security) {
                $scope.filteredSecurity = security;
                $scope.filteredExpiry = null;
                $scope.calculatePayoff();
            };

            $scope.updatePayoff = function (payoffData) {

                var seriesData = payoffData.dateSteps.map(function (d) {
                    return {
                        key: moment(d).format("MMM Do YYYY"),
                        values: []
                    }
                });

                var steps = (payoffData.priceSteps.length - 1) / 2;
                for (var i = 0; i < payoffData.priceSteps.length; i++) {

                    for (var j = 0; j < payoffData.dateSteps.length; j++) {


                        var dataPosition = j * payoffData.priceSteps.length + i;

                        seriesData[j].values.push({
                            x: i - steps,
                            y: payoffData.payOffData[dataPosition]
                        });
                    }
                }

                $scope.points = payoffData.points;
                $scope.priceSteps = payoffData.priceSteps;
                $scope.payoffData = seriesData;
            };

            $scope.payoffDataOptions = {
                chart: {
                    type: "lineChart",
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 40,
                        left: 55
                    },
                    x: function (d) {
                        return d.x;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    interactiveLayer: {
                        tooltip: {
                            contentGenerator: function (event) {

                                var priceFilter = $filter("price");
                                var numberFormat = $filter("tfcurrency");
                                var daysFilter = $filter("daysFromNow");

                                var steps = ($scope.priceSteps.length - 1) / 2;

                                var expiry = event.series[event.series.length - 1].key;

                                var priceIndex = event.value + steps;
                                var price = $scope.priceSteps[priceIndex];
                                var header = "<h3> Price " + priceFilter(price, $scope.points) + "</h3>";

                                var content = event.series.map(function (row) {
                                    var rowClass = row.highlight ? "highlight" : "";
                                    var valueClass = row.value < 0 ? "sell" : "buy";
                                    var difference = daysFilter(moment(expiry, "MMM Do YYYY"), moment(row.key, "MMM Do YYYY"));

                                    return "<tr class='" + rowClass + "'>" +
                                        "<td class='legend-color-guide' style='border-color: " + row.color + "'>" +
                                        "<div style='background-color:" + row.color + "'></div>" +
                                        "</td>" +
                                        "<td class='key' style='border-color: " + row.color + "'>" +
                                        row.key +
                                        "<div style='font-size: 11px'>" + difference + " days to expiry</div>" +
                                        "</td>" +
                                        "<td class='value' style='font-size: 1.1em; border-color: " + row.color + ";'>" +
                                        "<span class='" + valueClass + "'>" +
                                        numberFormat(row.value, 2) +
                                        "</span>" +
                                        "</td>" +
                                        "</tr>"
                                }).join("\n");
                                return header + "<table><tbody>" + content + "</tbody></table>"
                            }
                        }
                    },
                    dispatch: {},
                    xAxis: {
                        axisLabel: "Price Change",
                        tickFormat: function (d) {
                            var steps = ($scope.priceSteps.length - 1) / 2;

                            var index = d + steps;
                            if ($scope.points) {
                                return d3.format(",.01f")($scope.priceSteps[index]);
                            } else {
                                return d3.format(",.03f")($scope.priceSteps[index]);
                            }
                        }

                    },
                    yAxis: {
                        axisLabel: "Payoff ($)",
                        tickFormat: function (d) {
                            return d3.format(",f")(d);
                        },
                        axisLabelDistance: -10
                    }
                }
            };

            $scope.timeSeries = {
                value: 3,
                options: {
                    floor: 2,
                    ceil: 8,
                    onEnd: function (id) {
                        $scope.calculatePayoff();
                    }
                }
            };

            $scope.pricePoints = {
                value: 5,
                options: {
                    floor: 5,
                    ceil: 25,
                    onEnd: function (id) {
                        $scope.calculatePayoff();
                    }
                }
            };

            $scope.inputs = {
                timeSeries: 3,
                pricePoints: 10,
                scenarios: null
            };

            $scope.toggleIncludeRealPositions = function () {
                $scope.payoff.includeRealPositions = !$scope.payoff.includeRealPositions;
                $scope.filteredSecurity = null;
                $scope.filteredExpiry = null;
                $scope.getAvailSecurities();
                $scope.calculatePayoff();
            };

            $scope.filterExpiry = function (expiry) {
                $scope.filteredExpiry = expiry;
                $scope.calculatePayoff();
            };

            $scope.getTradesForPayoff = function () {
                var tradesForPayoff = [];

                if ($scope.currentWhatIfTrades != null) {
                    $scope.currentWhatIfTrades.forEach(function (t) {
                        var trade = {
                            quantity: t.quantity,
                            code: t.code,
                            expiry: t.expiry
                        };
                        tradesForPayoff.push(trade)
                    });
                }

                if ($scope.payoff.includeRealPositions && $scope.realPositions) {
                    $scope.realPositions.forEach(function (p) {
                        var trade = {
                            quantity: p.quantity,
                            code: p.code,
                            expiry: p.expiry
                        };
                        tradesForPayoff.push(trade);
                    });
                }

                if ($scope.filteredSecurity) {
                    tradesForPayoff = tradesForPayoff.filter(function (t) {
                        return (t.code.indexOf($scope.filteredSecurity) > -1);
                    })
                }

                var expiries = [];
                tradesForPayoff.forEach(function (trade) {
                    expiries.push(trade.expiry);
                });

                $scope.availableExpiries = expiries.filter(function (exp) {
                    return exp != null
                }).filter(function (elem, index, self) {
                    return index === self.indexOf(elem);
                }).sort(byValue);

                if ($scope.filteredExpiry != null) {
                    tradesForPayoff = tradesForPayoff.filter(function (t) {
                        return t.expiry === $scope.filteredExpiry;
                    })
                }

                return tradesForPayoff;
            };

            $scope.getEquityTradesForPayoff = function () {
                var tradesForPayoff = [];

                if ($scope.currentWhatIfEquityTrades != null) {
                    $scope.currentWhatIfEquityTrades.forEach(function (c) {
                        var trade = {
                            quantity: c.quantity,
                            code: c.code
                        };
                        tradesForPayoff.push(trade);
                    });
                }

                if ($scope.payoff.includeRealPositions && $scope.realEquityPositions != null) {
                    $scope.realEquityPositions.forEach(pos => {
                        const trade = {
                            code: pos.code,
                            quantity: pos.quantity
                        };
                        tradesForPayoff.push(trade);
                    })
                }

                if ($scope.filteredSecurity) {
                    tradesForPayoff = tradesForPayoff.filter(function (t) {
                        return (t.code.indexOf($scope.filteredSecurity) > -1);
                    })
                }

                return tradesForPayoff;
            };

            // TODO Once all screens are updated to use the new chart, most of this code can disappear
            $scope.calculatePayoff = function () {

                var equityTrades = $scope.getEquityTradesForPayoff();
                var tradesForPayoff = $scope.getTradesForPayoff();
                tradesForPayoff.forEach(function (t) {
                    delete t.expiry;
                });

                $scope.payoffParams = {
                    priceModifier: $scope.inputs.priceModifier,
                    timeSteps: $scope.inputs.timeSeries,
                    priceSteps: $scope.inputs.pricePoints,
                    scenarios: $scope.inputs.scenarios,
                    trades: tradesForPayoff,
                    equityTrades: equityTrades
                };

                let payoffChartInputId;

                if ($scope.activeStrategy != null) {
                    payoffChartInputId = $scope.activeStrategy.id;
                } else if ($scope.activeWhatIf != null) {
                    payoffChartInputId = $scope.activeWhatIf.id;
                } else {
                    payoffChartInputId = null;
                }

                $scope.payoffChartInput = {
                    id: payoffChartInputId,
                    optionTrades: tradesForPayoff,
                    equityTrades
                };

                $http.post("/tradefloor/api/payoff/tf", $scope.payoffParams)
                    .then(function (response) {
                        var data = response.data;
                        $scope.updatePayoff(data);
                        $scope.updateChartHeight();
                    });
            };

            $scope.$on("stress.scenario.change", function updateData(event, scenario) {
                if (!scenario) {
                    $scope.inputs.scenarios = null;
                } else {
                    if (scenario != null) {
                        $scope.inputs.scenarios = {
                            marketScenario: scenario.marketScenario,
                            securityScenarios: scenario.securityScenarios,
                            sectorScenarios: scenario.sectorScenarios
                        };
                        if ($scope.inputs.scenarios.marketScenario && $scope.inputs.scenarios.marketScenario.price == null && $scope.inputs.scenarios.marketScenario.vol == null) {
                            $scope.inputs.scenarios.marketScenario = null;
                        }
                    } else {
                        $scope.inputs.scenarios = null;
                    }
                }
                $scope.calculatePayoff();
            });

            $scope.widgetContentHeight = 250;

            $scope.$on("gridster-resized", function () {
                $scope.updateChartHeight();
            });

            $scope.$on("gridster-item-resized-stop", function (widget) {
                $scope.updateChartHeight();
            });

            $scope.$watch("gridsterItem.sizeY", function () {
                $scope.updateChartHeight();
            });

            var payOffChartApi;

            $scope.payOffChartReady = function ($scope, $elem) {
                payOffChartApi = $scope.api
            };

            $scope.updateChartHeight = function () {
                // Depending on the mode the UI is set to, we may or may not be running inside Gridster
                if ($scope.gridsterItem != null) {
                    var widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);
                    $scope.payoffDataOptions.chart.height = widgetContentHeight - 30;
                }
                if (payOffChartApi != null) {
                    payOffChartApi.update();
                }
            };

            $scope.calculatePayoff();

            $scope.$on("margin.whatif.changed", function (event, whatIfMargin, scenarioMargin, currentMargin, eodMargin, marginData) {
                updateData(whatIfMargin, scenarioMargin, currentMargin, eodMargin, marginData);
            });

            if ($scope.lastMarginWhatifChangedData && $scope.lastMarginWhatifChangedData.whatIfMargin) {
                updateData($scope.lastMarginWhatifChangedData.whatIfMargin,
                    $scope.lastMarginWhatifChangedData.scenarioMargin,
                    $scope.lastMarginWhatifChangedData.currentMargin,
                    $scope.lastMarginWhatifChangedData.eodMargin,
                    $scope.lastMarginWhatifChangedData.marginData);
            }

            function updateData(whatIfMargin, scenarioMargin, currentMargin, eodMargin, marginData) {
                $scope.realPositions = currentMargin.positions;
                $scope.realEquityPositions = marginData.equityPositions;
                $scope.currentWhatIfTrades = marginData.positions.filter(pos => pos.code.length > 3);
                $scope.currentWhatIfEquityTrades = marginData.positions.filter(pos => pos.code.length === 3);

                var activeWhatIf = whatIfMargin;
                if (!activeWhatIf) {
                    $scope.payoff.includeRealPositions = true;
                }
                if (activeWhatIf) {
                    $scope.whatIf = activeWhatIf;
                } else {
                    $scope.whatIf = null
                }
                $scope.getAvailSecurities();
                $scope.calculatePayoff();
            }
        }]);
}
